const info = {
    $schema: '../../assetlist.schema.json',
    chain_name: 'xiontestnet2',
    assets: [
        {
            description: 'The native staking token of the Xion network.',
            denom_units: [{
                    denom: 'uxion',
                    exponent: 0,
                    aliases: ['microxion']
                }, {
                    denom: 'XION',
                    exponent: 6,
                    aliases: ['xion']
                }],
            base: 'uxion',
            display: 'XION',
            name: 'xion',
            symbol: 'XION',
            logo_URIs: {
                png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/xion/images/burnt-round.png'
            },
            images: [{
                    png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/xion/images/burnt-round.png'
                }],
            socials: {
                discord: 'https://discord.com/invite/burnt',
                github: 'https://github.com/burnt-labs',
                telegram: 'https://t.me/xion_announcements',
                twitter: 'https://x.com/burnt_xion',
                website: 'https://xion.burnt.com'
            },
            type_asset: 'sdk.coin'
        },
        {
            denom_units: [{
                    denom: 'ibc/13B2C536BB057AC79D5616B8EA1B9540EC1F2170718CAFF6F0083C966FFFED0B',
                    exponent: 0,
                    aliases: ['uosmo']
                }, {
                    denom: 'osmo',
                    exponent: 6
                }],
            type_asset: 'ics20',
            base: 'ibc/13B2C536BB057AC79D5616B8EA1B9540EC1F2170718CAFF6F0083C966FFFED0B',
            name: 'Osmosis OSMO Token',
            display: 'osmo',
            symbol: 'OSMO',
            traces: [{
                    type: 'ibc',
                    counterparty: {
                        chain_name: 'osmosistestnet',
                        base_denom: 'uosmo',
                        channel_id: 'channel-10231'
                    },
                    chain: {
                        channel_id: 'channel-2',
                        path: 'transfer/channel-2/uosmo'
                    }
                }],
            images: [{
                    image_sync: {
                        chain_name: 'osmosistestnet',
                        base_denom: 'uosmo'
                    },
                    png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/osmo.png',
                    svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/osmo.svg'
                }],
            logo_URIs: {
                png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/osmo.png',
                svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/osmo.svg'
            },
            coingecko_id: 'osmosis'
        },
        {
            denom_units: [{
                    denom: 'ibc/6490A7EAB61059BFC1CDDEB05917DD70BDF3A611654162A1A47DB930D40D8AF4',
                    exponent: 0,
                    aliases: ['uusdc']
                }, {
                    denom: 'usdc',
                    exponent: 6
                }],
            type_asset: 'ics20',
            base: 'ibc/6490A7EAB61059BFC1CDDEB05917DD70BDF3A611654162A1A47DB930D40D8AF4',
            name: 'Noble USDC Token',
            display: 'usdc',
            symbol: 'USDC',
            coingecko_id: 'usd-coin',
            traces: [{
                    type: 'ibc',
                    counterparty: {
                        chain_name: 'nobletestnet',
                        base_denom: 'uusdc',
                        channel_id: 'channel-333'
                    },
                    chain: {
                        channel_id: 'channel-3',
                        path: 'transfer/channel-3/uusdc'
                    }
                }],
            images: [{
                    image_sync: {
                        chain_name: 'nobletestnet',
                        base_denom: 'uusdc'
                    },
                    svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.svg',
                    png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.png',
                    theme: {
                        circle: true,
                        primary_color_hex: '#2775CA'
                    }
                }],
            logo_URIs: {
                png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.png',
                svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/ethereum/images/usdc.svg'
            }
        }
    ]
};
export default info;
